/* @flow */

import * as React from 'react';
import {Creatable, type CreatableExtraProps, type SelectBaseProps} from 'react-select';
import {selectPickerGenericStyles} from './select-picker-generic-styles';

export type ActionMeta = {
    action:
        | 'select-option'
        | 'deselect-option'
        | 'remove-value'
        | 'pop-value'
        | 'set-value'
        | 'clear'
        | 'create-option',
};

export type Option = {value: string, label: string};

type Props = {|
    ...$Exact<SelectBaseProps>,
    ...$Exact<CreatableExtraProps>,
    value?: ?Option,
    /** Unfortunately for now because of https://github.com/JedWatson/react-select/issues/2953, we have to use `value` and `label` keys */
    options: Option[],
    /** Not allowing multiple selections in this component */
    isMulti?: false,
    onChange?: (newValue: Option, actionMeta: ActionMeta) => void,
    /** Added for simplicity, components usually need to handle clearing differently from changes */
    onClear?: () => void,
|};

export class SelectPickerGenericCreatable extends React.Component<Props> {
    render() {
        // eslint-disable-next-line no-unused-vars
        const {onChange, ...restProps} = this.props;

        return (
            <Creatable
                {...restProps}
                isMulti={false}
                getOptionValue={undefined}
                getOptionLabel={undefined}
                onChange={this.handleChange}
                styles={selectPickerGenericStyles}
            />
        );
    }

    handleChange: $PropertyType<$PropertyType<Creatable, 'props'>, 'onChange'> = (
        newValue,
        actionMeta
    ) => {
        if (Array.isArray(newValue)) {
            // There's a bug, where backspacing to clear sends an array.
            // https://github.com/JedWatson/react-select/pull/3216 should fix it
            if (newValue.length === 0) {
                if (this.props.onClear) {
                    this.props.onClear();
                }

                return;
            }
            throw new Error(
                `Somehow got an array value in an onChange (${actionMeta.action}): ${JSON.stringify(
                    newValue
                )}`
            );
        }

        if (actionMeta.action === 'clear' || newValue === null || typeof newValue === 'undefined') {
            if (this.props.onClear) {
                this.props.onClear();
            }
        } else if (this.props.onChange) {
            this.props.onChange(newValue, actionMeta);
        }
    };
}
